import { render, staticRenderFns } from "./zhuan.vue?vue&type=template&id=c0956e38&"
import script from "./zhuan.vue?vue&type=script&lang=js&"
export * from "./zhuan.vue?vue&type=script&lang=js&"
import style0 from "./zhuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports